<template>
  <div class="container containerForm">
    <h2 class="text-center">تعديل القسم</h2>
    <form @submit.prevent="updateCategory">
      <div class="form-group">
        <label for="name_ar">الاسم بالعربية</label>
        <input
          type="text"
          class="form-control"
          id="name_ar"
          v-model="editedCategory.name_ar"
          :class="{ 'is-invalid': errors.name_ar }"
        />
        <div v-if="errors.name_ar" class="invalid-feedback">
          {{ errors.name_ar }}
        </div>
      </div>
      <div class="form-group">
        <label for="name_en">الاسم بالإنجليزية</label>
        <input
          type="text"
          class="form-control"
          id="name_en"
          v-model="editedCategory.name_en"
          :class="{ 'is-invalid': errors.name_en }"
        />
        <div v-if="errors.name_en" class="invalid-feedback">
          {{ errors.name_en }}
        </div>
      </div>
      <div class="form-group">
        <label for="image">صورة القسم</label>
        <input
          type="file"
          accept="image/*"
          class="form-control"
          id="image"
          @change="handleImageChange"
        />
      </div>
      <button type="submit" class="btn btn-primary">
        حفظ
      </button>
    </form>
  </div>
</template>

<script>
import Axios from "../../../Axios";

export default {
  data() {
    return {
      editedCategory: {
        name_ar: "",
        name_en: "",
        image: "",
      },
      errors: {
        name_ar: "",
        name_en: "",
      },
      categoryId: this.$route.params.id,
    };
  },
  computed: {
    hasErrors() {
      return this.errors.name_ar || this.errors.name_en;
    },
  },
  methods: {
    validateInput() {
      const arabicLettersRegex = /^[\u0621-\u064A\s]+$/;
      const englishLettersRegex = /^[A-Za-z\s]+$/;

      this.errors = {
        name_ar: "",
        name_en: "",
      };

      if (!this.editedCategory.name_ar) {
        this.errors.name_ar = "الرجاء إدخال الاسم بالعربية";
      } else if (!arabicLettersRegex.test(this.editedCategory.name_ar)) {
        this.errors.name_ar = "الرجاء إدخال حروف عربية فقط";
      }

      if (!this.editedCategory.name_en) {
        this.errors.name_en = "الرجاء إدخال الاسم بالإنجليزية";
      } else if (!englishLettersRegex.test(this.editedCategory.name_en)) {
        this.errors.name_en = "الرجاء إدخال حروف إنجليزية فقط";
      }
    },
    updateCategory() {
      this.validateInput();

      if (this.hasErrors) {
        return;
      }

      const { name_ar, name_en, image } = this.editedCategory;

      Axios.patch(
        `/category/${this.categoryId}`,
        {
          name_en,
          name_ar,
          image,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
        .then((response) => {
          this.$iziToast.success({
            timeout: 2000,
            message: "تم التحديث بنجاح",
            position: "bottomRight",
          });
          this.$router.push("/admin/categories");
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            const errorMessage = error.response.data.errors[0];
            this.$iziToast.error({
              timeout: 5000,
              message: errorMessage,
              position: "bottomRight",
            });
          } else {
            this.$iziToast.error({
              timeout: 2000,
              message: "فشل التحديث",
              position: "bottomRight",
            });
          }
        });
    },
    handleImageChange(event) {
      const selectedImage = event.target.files[0];
      if (selectedImage) {
        this.editedCategory.image = selectedImage;
      }
    },
    fetchCategoryDetails() {
      Axios.get(`/dashboard/category/${this.categoryId}`)
        .then((response) => {
          const categoryData = response.data.data.categoryData;
          this.editedCategory.name_ar = categoryData.name_ar;
          this.editedCategory.name_en = categoryData.name_en;
        })
        .catch((error) => {
          // console.error(error);
        });
    },
  },
  mounted() {
    this.fetchCategoryDetails();
  },
};
</script>